import React from 'react';
import PasswordPage from '../../features/password/PasswordPage';
export default function PasswordReset() {
  return <PasswordPage mode="reset" />;
}
